import actionCreatorFactory from 'typescript-fsa';
import { KansatsuKirokuObsrec } from '../../../models/KansatsuKirokuObsrec';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('kansatsuKirokuObsrec');

// 一覧取得
const fetchRecords = actionCreator.async<
  {
    koujiBangou: string
  }, // started: parameter type
  {
    Items: KansatsuKirokuObsrec[];
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('FETCH_RECORDS');

// 単一レコードの取得
const getRecord = actionCreator.async<
  {
    koujiBangou: string;
    key: string;
  }, // started: parameter type
  {
    Item: KansatsuKirokuObsrec;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('GET_RECORD');

// 単一レコードの取得
const getLatestRecord = actionCreator.async<
{
  koujiBangou: string;
}, // started: parameter type
{
  Item: KansatsuKirokuObsrec;
}, // done: success type
{
  error: string
} // failed: error type
>('GET_LATEST_RECORD');

// 単一レコードの登録
const postRecord = actionCreator.async<
  {
    item: KansatsuKirokuObsrec;
  }, // started: parameter type
  {
    item: KansatsuKirokuObsrec;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('POST_RECORD');

const resetRecord = actionCreator('RESET_RECORD');

export {
  fetchRecords,
  getRecord,
  postRecord,
  resetRecord,
  getLatestRecord
};



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKirokuObsrec/actions.ts